












import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class BaseDivider extends Vue {
  // Prop to control the vertical margin (top and bottom).
  // Can be any valid CSS margin value (e.g., '3rem', '24px').
  @Prop({ type: String, default: '2rem' })
  readonly verticalMargin!: string;

  // Prop to control the horizontal margin (left and right).
  // Can be any valid CSS margin value (e.g., '3rem', '24px').
  @Prop({ type: String, default: '0' })
  readonly horizontalMargin!: string;

  // Prop to control the color of the divider line.
  @Prop({ type: String, default: '#EDEEF1' })
  readonly color!: string;

  @Prop({ type: String, default: '0.1rem' })
  readonly lineThickness!: string;

  get dividerStyles() {
    return {
      // Build the margin shorthand property
      margin: `${this.verticalMargin} ${this.horizontalMargin}`,
      borderTop: `${this.lineThickness} solid ${this.color}`,
    };
  }
}
